import { render } from "./InsertShipment.vue?vue&type=template&id=384bd66a&scoped=true"
import script from "./InsertShipment.vue?vue&type=script&lang=js"
export * from "./InsertShipment.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./InsertShipment.vue?vue&type=style&index=1&id=384bd66a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384bd66a"]])

export default __exports__